import SignUp from "components/SignUp/SignUp";
import React from "react";

const Signup = () => {
  return <SignUp />;
};

export default Signup;
